import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { CalendarMonth as CalendarIcon } from '@mui/icons-material';

const visibleDateFieldSx = {
  '& .MuiInputAdornment-root .MuiSvgIcon-root': {
    color: 'primary.main',
    fontSize: 22,
    opacity: 1,
  },
  '& input[type="date"]::-webkit-calendar-picker-indicator': {
    opacity: 1,
    cursor: 'pointer',
    filter: 'invert(38%) sepia(77%) saturate(547%) hue-rotate(90deg) brightness(95%) contrast(92%)',
  },
};

const VisibleDateField = ({ sx, slotProps, ...props }) => {
  return (
    <TextField
      {...props}
      type="date"
      slotProps={{
        inputLabel: {
          ...(slotProps?.inputLabel || {}),
          shrink: true,
        },
        input: {
          ...(slotProps?.input || {}),
          startAdornment: (
            <InputAdornment position="start">
              <CalendarIcon />
            </InputAdornment>
          ),
        },
      }}
      sx={[visibleDateFieldSx, ...(Array.isArray(sx) ? sx : [sx].filter(Boolean))]}
    />
  );
};

export default VisibleDateField;